export default "__VITE_ASSET__dWyKNPm5__";